import {usageStat} from 'api/usageStat';
import Cookies from 'js-cookie';

const usageStatistics = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        usageStat({commit},params) {
            return new Promise((resolve, reject) => {
                usageStat(params.month, params.type).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default usageStatistics;



// WEBPACK FOOTER //
// ./src/store/modules/usageStat.js